module.exports = __webpack_public_path__ + "static/media/p2.2ec9e486.jpg";